module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "ack01"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "chaptertitle",
    attrs: {
      "id": "p_1"
    }
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_2"
    }
  }, [_vm._v("The University of Scranton gave me a sabbatical and some released time from teaching in order to do research and to write my book on Catholic social doctrine. For this allotted time I am grateful to the provost, Dr. Hal Baillie, to two former deans of the College of Arts and Sciences, Drs. Joseph Dreisbach and Paul Fahey, and to those faculty who approved my sabbatical application. I am much in debt to my first teacher of Catholic social doctrine, Rev. Ernest Fortin, A.A., and to Marie Gaughan, the secretary of the Department of Theology and Religious Studies, for the various kinds of help that she so promptly and generously gave me. In addition, I want to express my heartfelt thanks to Rev. Joseph Tylenda, S.J., Professors Mary Keys and Joseph Capizzi for their helpful comments on my entire manuscript, my copy editor, Aldene Fredenburg, my proof reader and daughter, Elizabeth Benestad, and above all my wife, Janet, who engaged me in serious conversation on Catholic social doctrine and read every chapter with a critical eye. I say with gratitude that she always loved truth more than her husband.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_3"
    }
  }, [_vm._v("I would be remiss not to offer special thanks to David McGonagle and Fr. Romanus Cessario, O.P., for their invitation to write this book and for their patience in waiting for its completion. For their encouragement and counsel I thank Bishop John Dougherty and my friends Rev. Matthew Lamb, Drs. Edward Capestany, Robert Hueston, Marc Guerra, and Greg Burke.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_4"
    }
  }, [_vm._v("In writing this book I made ample use of material that I have previously published elsewhere. The chapters in which these articles appear, in whole or in part, are listed below. Publication data and permissions are indicated.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "p_5"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_6"
    }
  }, [_vm._v("“Understanding the Opposition to Pope John Paul II's "), _c('i', [_vm._v("Evangelium Vitae")]), _vm._v(" in the Light of Alexis de Tocqueville's "), _c('i', [_vm._v("Democracy in America")]), _vm._v(",” in "), _c('i', [_vm._v("Proceedings of the Pontifical Academy for Life")]), _vm._v(", edited by Juan Correa and Elio Sgreccia (Vatican City: Libreria Editrice Vaticana, 2001), 502–12. By permission\n"), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v("\nof the Pontifical Academy for Life. “Do Today's Catholics Know Anything about the Church's Social Teachings?” in "), _c('i', [_vm._v("Keeping Faith")]), _vm._v(", edited by Patrick G. D. Riley (Front Royal, Va.: Christendom Press, 2000), 31–61. By permission of Christendom Press.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "p_7"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_8"
    }
  }, [_vm._v("Janet P. Benestad and J. Brian Benestad, “Human Dignity: The Heart of Catholic Social Teaching,” in "), _c('i', [_vm._v("The Great Life: Essays on Doctrine and Holiness in Honor of Father Ronald Lawler, O.F.M. Cap")]), _vm._v(" (Steubenville, Ohio: Emmaus Road Publishing, 2005), 63–85. By permission of Emmaus Road Publishing. “Do Today's Catholics Know Anything About the Church's Social Teachings?” By permission of Christendom Press.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_9"
    }
  }, [_vm._v("“The Distorted Understanding of Human Dignity in Liberal Regimes,” in "), _c('i', [_vm._v("The Dignity of the Dying Person: Proceedings of the Fifth Assembly of the Pontifical Academy for Life")]), _vm._v(", edited by Juan Correa and Elio Sgreccia (Vatican City: Libreria Editrice Vaticana, 2000), 368–72. By permission of the Pontifical Academy for Life. “Henry George and the Catholic View of Morality and the Common Good I,” "), _c('i', [_vm._v("American Journal of Economics and Sociology")]), _vm._v(" 44, no. 3 (1985): 365–78. By permission of Blackwell Publishing. “Philosophy, Political Philosophy and Historicism in Pope John Paul II's "), _c('i', [_vm._v("Fides et Ratio")]), _vm._v(",” In "), _c('i', [_vm._v("Gladly to Learn and Gladly to Teach: Essays on Religion and Political Philosophy in Honor of Ernest L. Fortin, A.A")]), _vm._v("., 53–67 (Lanham, Md.: Rowman and Littlefield, 2002). By permission of Rowman and Littlefield.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_10"
    }
  }, [_vm._v("“Review essay on Leon Kass's "), _c('i', [_vm._v("Life, Liberty and the Defense of Dignity: The Challenge for Bioethics")]), _vm._v(",” in "), _c('i', [_vm._v("Etica Della Ricerca Biomedica: Per Una Visione Cristiana")]), _vm._v(", edited by Juan Correa and Elio Sgreccia, 22–30 (Rome: Pontifical Academy for Life, 2004). By permission of the Pontifical Academy for Life. “Review Essay on Leon Kass's "), _c('i', [_vm._v("Life, Liberty and the Defense of Dignity: The Challenge for Bioethics")]), _vm._v(" and "), _c('i', [_vm._v("Toward a More Natural Science: Biology and Human Affairs,” National Catholic Bioethics Quarterly")]), _vm._v(" 5, no. 3 (Autumn 2005): 631–45. By permission of the National Catholic Bioethics Center.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "p_11"
    }
  }, [_vm._v("Chapter 3")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_12"
    }
  }, [_vm._v("“Ordinary Virtue as Heroism,” in "), _c('i', [_vm._v("Seedbeds of Virtue")]), _vm._v(", edited by Mary Ann Glendon and David Blankenhorn, 221–52 (Lanham, Md.: Madison Books, 1995). By permission of Rowman and Littlefield.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "p_13"
    }
  }, [_vm._v("Chapter 4")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_14"
    }
  }, [_vm._v("“The Catholic Concept of Social Justice: A Historical Perspective,” "), _c('i', [_vm._v("Communio")]), _vm._v(" 11, no. 4 (1984): 364–81. By permission of "), _c('i', [_vm._v("Communio")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "p_15"
    }
  }, [_vm._v("Chapter 5")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_16"
    }
  }, [_vm._v("“Review essay on Leon Kass's "), _c('i', [_vm._v("Life, Liberty and the Defense of Dignity: The Challenge for Bioethics,”")]), _vm._v(" in "), _c('i', [_vm._v("Etica Della Ricerca Biomedica")]), _vm._v(". By permission of the Pontifical Academy for Life. “Review Essay on Leon Kass's "), _c('i', [_vm._v("Life, Liberty and the Defense of Dignity: The Challenge for Bioethics")]), _vm._v(" and "), _c('i', [_vm._v("Toward a More Natural Science: Biology and Human Affairs,” National Catholic Bioethics Quarterly")]), _vm._v(". By permission of the National Catholic Bioethics Center. “Review essay on "), _c('i', [_vm._v("Beyond Therapy: Biotechnology and the Pursuit of Happiness")]), _vm._v(" by the President's Council on Bioethics,” in "), _c('i', [_vm._v("La Dignitá Della Procreazione Umana E Le Tecnologie Riproduttive: Aspetti Antropologici Ed Etici")]), _vm._v(", edited by Juan Correa and Elio Sgreccia (Rome: Pontifical Academy for Life, 2005), 7–17. By permission of the Pontifical Academy for Life.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "p_17"
    }
  }, [_vm._v("Chapter 6")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_18"
    }
  }, [_vm._v("“The Statement of the U.S. Catholic Bishops on Faithful Citizenship: A Missed Opportunity,” "), _c('i', [_vm._v("Fellowship of Catholic Scholars Quarterly")]), _vm._v(" 27, no. 3 (Fall 2004): 3–12. By permission of the Fellowship of Catholic Scholars. “The Theology of the Laity,” "), _c('i', [_vm._v("The Newman Rambler")]), _vm._v(" 7, no. 1 (Summer 2003): 7–13. By permission of the Newman Centre at McGill University.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "p_19"
    }
  }, [_vm._v("Chapter 8")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_20"
    }
  }, [_vm._v("“Reflections on the Santa Clara Address of Father Peter-Hans Kolvenbach, S.J. "), _c('i', [_vm._v("Fellowship of Catholic Scholars Quarterly")]), _vm._v(" 24, no 3 (2001): 12–20. By permission of the Fellowship of Catholic Scholars.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "p_21"
    }
  }, [_vm._v("Chapter 9")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_22"
    }
  }, [_vm._v("“Welfare Reform and the Catholic Church: A Round Table Discussion,” "), _c('i', [_vm._v("Notre Dame Journal of Law, Ethics and Public Policy")]), _vm._v(" 2, no. 2 (1997): 697–700, 727–28. By permission of "), _c('i', [_vm._v("Notre Dame Journal of Law, Ethics and Public Policy")]), _vm._v(".")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "p_23"
    }
  }, [_vm._v("Chapter 11")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_24"
    }
  }, [_vm._v("“Dignity in the United Nations Declaration of Human Rights,” in "), _c('i', [_vm._v("Natura e Dignita Della Persona Umana a Fondamento Del Diritto Alla Vita. Le Sfide Del Contesto Culturale Contemporaneo")]), _vm._v(", edited by Juan Correa and Elio Sgreccia, 143–52 (Rome: Pontifical Academy for Life, 2003). By permission of the Pontifical Academy for Life.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "p_25"
    }
  }, [_vm._v("Chapter 12")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_26"
    }
  }, [_vm._v("“Just War Principles,” in "), _c('i', [_vm._v("The Catholic Citizen: Debating the Issues of Justice")]), _vm._v(", proceedings of the 26th Annual Convention of the Fellowship of Catholic Scholars, edited by Kenneth Whitehead (South Bend, Ind.: St. Augustine's Press, 2004). By permission of the Fellowship of Catholic Scholars.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "p_27"
    }
  }, [_vm._v("Conclusion")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_28"
    }
  }, [_vm._v("“The Liberal Insistence That Religion Is a Private Affair,” in "), _c('i', [_vm._v("Die Bedeutung der Religion für die Gesellschaft: Erfahrungen und Problemen in Deutschland und den USA")]), _vm._v(", edited by Anton Rauscher, 109–26 (Berlin: Duncker & Humblot, 2004). By permission of Dunker and Humblot GMbh.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0810b5b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgments.vue
// module id = 75
// module chunks = 0